import Vue from 'vue'
import VueRouter from 'vue-router'
import AboutView from '../views/AboutView'
import userBieyangai from '../views/userBieyangai'
import userNiou from '../views/userNiou'
import userShxf from '../views/userShxf'
import userYffz from '../views/userYffz'
import cwXq from '../views/cwXq'
import userYulian from '../views/userYulian'
import pcHome from '../views/official/pcHome';
import rechargePage from '@/views/rechargePage.vue';
import iosGw from '../views/iosGw'
Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: ''
    
  },
  {
    path: '',
    name: 'about',
    component: AboutView,
    meta: {
      title: '不止网络' // 设置页面标题为'首页'
    }
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: rechargePage,
    meta: {
      title: '不止网络' // 设置页面标题为'首页'
    }
  },
  {
    path: '/index',
    name: 'pcHome',
    component: pcHome,
    meta: {
      title: '不止网络' // 设置页面标题为'首页'
    }
  },
  {
    path: '/user/bieyangai',
    name: 'about',
    component: userBieyangai,
    meta: {
      title: '不止网络' // 设置页面标题为'首页'
    }
  },
  {
    path: '/user/niou',
    name: 'about',
    component: userNiou,
    meta: {
      title: '不止网络' // 设置页面标题为'首页'
    }
  },
  {
    path: '/cwxq',
    name: 'about',
    component: cwXq,
    meta: {
      title: '不止网络' // 设置页面标题为'首页'
    }
  },
  {
    path: '/user/yulian',
    name: 'about',
    component: userYulian,
    meta: {
      title: '不止网络' // 设置页面标题为'首页'
    }
  },
    {
    path: '/yffz',
    name: 'about',
    component: userYffz,
    meta: {
      title: '不止网络' // 设置页面标题为'首页'
    }
  },
    {
    path: '/shxf',
    name: 'about',
    component: userShxf,
    meta: {
      title: '不止网络' // 设置页面标题为'首页'
    }
  },
    {
    path: '/user/iosGw',
    name: 'about',
    component: iosGw,
    meta: {
      title: '不止网络' // 设置页面标题为'首页'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  // document.title = to.meta.title || '默认标题'; // 如果有设置页面标题则使用设置的标题，否则使用默认标题
  const currentDomain = window.location.hostname;
  // let { hostname, pathname } = window.location;
  // hostname.match("bzxd.tv")
  // 根据域名设置不同的页面标题
  if (currentDomain.match("jiubanapp.com")||currentDomain.match("qtqingtou.cn")||currentDomain.match("qingxinliaoqx.cn")||currentDomain.match("xinxinliao.cn")||currentDomain.match("dayliao.cn")||currentDomain.match("joyliao.cn")) {
    document.title = '海南豪旺';
  }else if(currentDomain.match("huanyuanapp.cn")){
    document.title = '满乐游网络';
  } else if(currentDomain.match("youyuanonline.cn")){
    document.title = '满乐游科技';
  }else if(currentDomain.match("hnzhengqiang.cn")||currentDomain.match("hehuanapp.cn")||currentDomain.match("huanyueapp.cn")){
    document.title = '海南正强网络科技有限公司';
  } else if ( currentDomain.match("ruyuanapp.cn")||currentDomain.match("jiuyuanapp.cn")) {
    document.title = '海南尼豆网络科技有限公司';
  } else if ( currentDomain.match("changyuanapp.cn")||currentDomain.match("qingqianapp.cn")||currentDomain.match("ylyulian.cn")||currentDomain.match("yuanquapp.cn")||currentDomain.match("yuyuanyy.cn")||currentDomain.match("hanqingmomoapp.cn")||currentDomain.match("hongdouxiangsi.cn")||currentDomain.match("xiusekeren.cn")) {
    document.title = '上海璟栝网络科技有限公司';
  }else if ( currentDomain.match("wanmeiwanban.cn") ||currentDomain.match("wanmeidazi.com" )||currentDomain.match("yiqiwanban.cn" ) ) {
    document.title = '完美搭子';
  }else if ( currentDomain.match("linghunxiehou.cn") ||currentDomain.match("xintiaoxiehou.cn" )||currentDomain.match("xianwaizhiyin.cn" )||currentDomain.match("miyuhuisheng.cn" )||currentDomain.match("xinyuxinyuan.com.cn" ) ) {
    document.title = '上海薄客网络科技有限公司';
  }else if ( currentDomain.match("shanghaibotui.cn") ) {
    document.title = '上海博推网络科技有限公司';
  }
  
  else  {
    document.title = '不止心动';
  }
  // 继续路由导航
  next();
});

export default router
